import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import mixpanel, { initMixpanel } from "../../util/utilfunctions/mixpanel";

function MixpanelTracker() {
  const location = useLocation();

  const useMixPanel = useSelector(
    (state) => state.config.baseConfig?.useMixPanel
  );
  const mixKey = useSelector(
    (state) => state.config.baseConfig?.mixKey
  );
  console.log("useMixPanel1=====", useMixPanel);
  // console.log("useMixPanel2=====", mixKey);

  useEffect(() => {
    console.log("useMixPanellll=====", useMixPanel);

    const isEnabled = useMixPanel === "1";

    initMixpanel(isEnabled, mixKey);

    // initMixpanel(useMixPanel === "1");
  }, [useMixPanel, mixKey]);

  useEffect(() => {
    mixpanel.track_pageview({
      page: location.pathname,
      url: window.location.href,
    });
  }, [location]);

  return null;
}

export default MixpanelTracker;